export default "__VITE_ASSET__5b1NHsx3__"